import { Vector3 as e } from "three";
import { Direction as o } from "./index7.js";
const t = {
  [o.Right]: new e(1, 0, 0),
  [o.Left]: new e(-1, 0, 0),
  [o.Up]: new e(0, 1, 0),
  [o.Down]: new e(0, -1, 0),
  [o.Forward]: new e(0, 0, 1),
  [o.Back]: new e(0, 0, -1)
};
export {
  t as Vectors
};
//# sourceMappingURL=index36.js.map
